import React, { Component } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {}

  render() {
    if (this.state.hasError) {
      // Component specific fallback
      if (this.props?.fallback) return this.props.fallback;

      // Default fallback
      return (
        <Container fluid className='vh-100 '>
          <Row
            className='position-absolute w-100'
            style={{ top: '50%', transform: 'translateY(-50%)' }}>
            <Col></Col>
            <Col xs={10} md={8} lg={6} xl={4}>
              <Alert variant='danger' className='text-center'>
                <p className='mb-0'>
                  Tapahtui virhe. Yritä myöhemmin uudelleen.
                </p>
                <p className='mb-0'>
                  Error encountered. Please try again later.
                </p>
              </Alert>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;